import { useEffect, useState } from "react";
import { agent } from "./agent/runtime.js";
import type { AgentState } from "./agent/agentService.js";

/** Subscribe a component to the AgentService state. */
export function useAgent(): AgentState {
  const [state, setState] = useState<AgentState>(() => agent.getState());
  useEffect(() => agent.subscribe(setState), []);
  return state;
}
